import React, { useMemo, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Pagination,
  InputGroup,
  Form
} from 'react-bootstrap';

const OutstandingReports = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 8;
  const [searchQuery, setSearchQuery] = useState('');

  const outstandingData = [
    {
      id: 'OUT001',
      distributorName: 'Rajesh Kumar',
      lastTransaction: '2024-11-05 18:20',
      outstanding: 6500,
      remarks: 'Within permissible limit'
    },
    {
      id: 'OUT002',
      distributorName: 'Priya Sharma',
      lastTransaction: '2024-11-05 14:45',
      outstanding: 7500,
      remarks: 'Pending settlement follow-up'
    },
    {
      id: 'OUT003',
      distributorName: 'Rahul Verma',
      lastTransaction: '2024-11-04 20:15',
      outstanding: 8500,
      remarks: 'Advised to remit by weekend'
    },
    {
      id: 'OUT004',
      distributorName: 'Neha Joshi',
      lastTransaction: '2024-11-03 17:05',
      outstanding: 6300,
      remarks: 'Regular payer'
    },
    {
      id: 'OUT005',
      distributorName: 'Suresh Yadav',
      lastTransaction: '2024-11-03 11:50',
      outstanding: 16300,
      remarks: 'Escalated to distributor'
    },
    {
      id: 'OUT006',
      distributorName: 'Pooja Singh',
      lastTransaction: '2024-11-02 16:40',
      outstanding: 9300,
      remarks: 'Partial payment expected tomorrow'
    },
    {
      id: 'OUT007',
      distributorName: 'Deepak Sharma',
      lastTransaction: '2024-11-01 19:00',
      outstanding: 13250,
      remarks: 'Follow-up call scheduled'
    },
    {
      id: 'OUT008',
      distributorName: 'Manoj Tiwari',
      lastTransaction: '2024-10-31 15:10',
      outstanding: 6250,
      remarks: 'Awaiting NEFT confirmation'
    }
  ];

  const filteredData = useMemo(() => {
    if (!searchQuery) {
      return outstandingData;
    }

    return outstandingData.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [outstandingData, searchQuery]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage) || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatCurrency = (value) => `₹${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

  const getPaginationItems = () => {
    const items = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      } else if (currentPage >= totalPages - 2) {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = totalPages - 3; i <= totalPages; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
      } else {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      }
    }

    return items;
  };

  return (
    <Container fluid className="outstanding-reports-page p-4">
      <Row>
        <Col>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
                    Outstanding Reports
                  </h5>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <InputGroup style={{ maxWidth: '300px' }}>
                    <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #ddd' }}>
                      <i className="bi bi-search"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{ border: '1px solid #ddd' }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      {['Date', 'Time', 'Distributor Name', 'Amount', 'Remark'].map((column) => (
                        <th
                          key={column}
                          style={{
                            padding: '12px 16px',
                            fontWeight: 600,
                            color: '#555',
                            borderBottom: '2px solid #dee2e6',
                            fontSize: '13px',
                            textAlign: 'center'
                          }}
                        >
                          {column}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.length > 0 ? (
                      currentData.map((item) => {
                        const [date = '', time = ''] = item.lastTransaction.split(' ');
                        return (
                          <tr key={item.id} style={{ transition: 'background-color 0.2s' }}>
                            <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px', textAlign: 'center', verticalAlign: 'middle' }}>{date}</td>
                            <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', textAlign: 'center', verticalAlign: 'middle' }}>{time}</td>
                            <td
                              style={{
                                padding: '12px 16px',
                                color: '#333',
                                fontSize: '13px',
                                fontWeight: 500,
                                textAlign: 'center',
                                verticalAlign: 'middle'
                              }}
                            >
                              {item.distributorName}
                            </td>
                            <td
                              style={{
                                padding: '12px 16px',
                                color: '#333',
                                fontSize: '13px',
                                fontWeight: 600,
                                textAlign: 'center',
                                verticalAlign: 'middle'
                              }}
                            >
                              {formatCurrency(item.outstanding)}
                            </td>
                            <td style={{ padding: '12px 16px', color: '#555', fontSize: '13px', textAlign: 'center', verticalAlign: 'middle' }}>
                              <details style={{ display: 'inline-block' }}>
                                <summary
                                  style={{
                                    cursor: 'pointer',
                                    fontWeight: 500,
                                    color: '#0d6efd',
                                    listStyle: 'none',
                                    outline: 'none',
                                    textAlign: 'center'
                                  }}
                                >
                                  View
                                </summary>
                                <div style={{ marginTop: '8px', color: '#555', textAlign: 'left', minWidth: '200px' }}>{item.remarks}</div>
                              </details>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={5} className="text-center py-4" style={{ color: '#999' }}>
                          No outstanding data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
            <Card.Footer className="bg-white border-top" style={{ padding: '12px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Showing {filteredData.length === 0 ? 0 : indexOfFirstRow + 1} to {Math.min(indexOfLastRow, filteredData.length)} of {filteredData.length}
                  </div>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <Pagination className="mb-0">
                    <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                    <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                    {getPaginationItems()}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </Col>
      </Row>

      <style jsx="true">{`
        .outstanding-reports-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .outstanding-reports-page details > summary {
          list-style: none;
        }

        .outstanding-reports-page details > summary::-webkit-details-marker {
          display: none;
        }

        .pagination .page-link {
          color: #0d6efd;
          border: 1px solid #dee2e6;
          padding: 6px 12px;
          font-size: 14px;
        }

        .pagination .page-item.active .page-link {
          background-color: #0d6efd;
          border-color: #0d6efd;
          color: white;
        }

        .pagination .page-link:hover {
          background-color: #e7f1ff;
          border-color: #0d6efd;
          color: #0d6efd;
        }

        .pagination .page-item.disabled .page-link {
          color: #6c757d;
          pointer-events: none;
          background-color: #fff;
          border-color: #dee2e6;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }

          .pagination {
            font-size: 12px;
          }
        }
      `}</style>
    </Container>
  );
};

export default OutstandingReports;


